'use client'
import React from 'react'
import { useLocationQuery } from '@/src/queries/guest/location-query'
import { useUser } from '@/src/store/user-store'
import { Box, Flex, Image, Text } from '@chakra-ui/react'

const MinimumBalanceRedemption = () => {
  const { user } = useUser()
  const { data } = useLocationQuery()

  return (
    <Box className="rounded-2xl border-2 border-[#DDDDDD] px-4 py-2.5">
      {' '}
      <Text className="mb-1 text-sm font-semibold text-[#727272]">
        Minimum balance for redemption
      </Text>
      <Flex
        color="#727272"
        className="items-center justify-between"
        fontWeight={600}
        alignItems={'center'}
        fontSize={[20, 17, 22]}
      >
        {' '}
        <Text>
          {' '}
          {user?.countryShortname === 'IN' || data?.country === 'India'
            ? '130'
            : '1300'}{' '}
          LYK Coins
        </Text>{' '}
        <Image
          src="/rewards/compare.svg"
          alt="compare"
          boxSize={{ base: 4, sm: 5 }}
        />{' '}
        <Text>
          {' '}
          {user?.countryShortname === 'IN' || data?.country === 'India'
            ? 'US$2.60'
            : 'US$26.00'}
        </Text>
      </Flex>
    </Box>
  )
}

export default MinimumBalanceRedemption
